import { loadStripe } from '@stripe/stripe-js';
import React, { useState, useEffect } from 'react';

export default function StripeVerification()
{

    useEffect(() =>
    {
        loadModal();
    }, [])
    async function loadModal()
    {
        const stripe = await loadStripe(process.env.REACT_APP_STRIPE_PROMISE);

        if (!stripe) return;

        try
        {
            const response = await fetch('/create-verification-session', { method: 'POST' });
            const session = await response.json();

            const { error } = await stripe.verifyIdentity(session.client_secret);

            if (error)
            {
                console.error('[error]', error);
            } else
            {
                console.log('Verification submitted!');
            }
        } catch (err)
        {
            console.error('Failed to create verification session:', err);
        }
    };

    return (<></>);
}
